import { QuestionCircleOutlined } from '@ant-design/icons';
import { Row, Tooltip } from 'antd';

import styles from './DoughnutBoxTitle.module.css';

interface DoughnutBoxTitleProps {
  archetypeName: string;
  tooltipText?: string;
}

const DoughnutBoxTitle: React.FC<DoughnutBoxTitleProps> = ({ archetypeName, tooltipText = '' }) => {
  return (
    <Row justify="center" align="middle" className={styles.title__container}>
      <span>{archetypeName}</span>
      {tooltipText && (
        <Tooltip title={tooltipText}>
          <span className={styles.title__icon}>
            <QuestionCircleOutlined />
          </span>
        </Tooltip>
      )}
    </Row>
  );
};

export default DoughnutBoxTitle;
